import Velocity from 'touch-velocity';
let unlisten;
const nodes = [];
export const touchdrag = (node) => {
    nodes.push(node);
    if (!unlisten) {
        unlisten = registerEventListener();
    }
    return {
        destroy() {
            const index = nodes.indexOf(node);
            if (index !== -1)
                nodes.splice(index, 1);
            if (nodes.length === 0) {
                unlisten();
                unlisten = null;
            }
        }
    };
};
function registerEventListener() {
    var xDown = null;
    var yDown = null;
    var xDiff = null;
    var yDiff = null;
    var startEl = null;
    var xVelocity = null;
    var yVelocity = null;
    var swipeThreshold = 20; // px
    document.addEventListener('touchstart', handleTouchStart, { passive: false });
    document.addEventListener('touchmove', handleTouchMove, { passive: false });
    document.addEventListener('touchend', handleTouchEnd, { passive: false });
    return () => {
        document.removeEventListener('touchstart', handleTouchStart);
        document.removeEventListener('touchmove', handleTouchMove);
        document.removeEventListener('touchend', handleTouchEnd);
    };
    /**
     * Records current location on touchstart event
     * @param {object} e - browser event object
     * @returns {void}
     */
    function handleTouchStart(e) {
        // if the element is not registerd we stop listening for swipe events
        if (!nodes.some(_ => _.contains(e.target)))
            return;
        startEl = e.target;
        xDown = e.touches[0].clientX;
        yDown = e.touches[0].clientY;
        xDiff = 0;
        yDiff = 0;
        xVelocity = new Velocity();
        yVelocity = new Velocity();
    }
    /**
     * Records location diff in px on touchmove event
     * @param {object} e - browser event object
     * @returns {void}
     */
    function handleTouchMove(e) {
        if (startEl) {
            if (!xDown || !yDown)
                return;
            var xUp = e.touches[0].clientX;
            var yUp = e.touches[0].clientY;
            yVelocity.updatePosition(yUp);
            xVelocity.updatePosition(xUp);
            xDiff = xDown - xUp;
            yDiff = yDown - yUp;
            var direction;
            if (Math.abs(xDiff) > Math.abs(yDiff)) { // most significant
                if (Math.abs(xDiff) > swipeThreshold) {
                    direction = xDiff > 0 ? 'left' : 'right';
                }
            }
            else if (Math.abs(yDiff) > swipeThreshold) {
                direction = yDiff > 0 ? 'up' : 'down';
            }
            if (direction) {
                var eventData = {
                    dir: direction,
                    xStart: xDown,
                    yStart: yDown,
                    xNow: xUp,
                    yNow: yUp,
                    xDiff,
                    yDiff,
                    xSpeed: xVelocity.getVelocity(),
                    ySpeed: yVelocity.getVelocity(),
                };
                const result = startEl.dispatchEvent(new CustomEvent('touch-drag', { bubbles: true, cancelable: true, detail: eventData }));
                if (!result) {
                    e.preventDefault();
                }
            }
        }
    }
    /**
     * Fires swiped event if swipe detected on touchend
     * @param {object} e - browser event object
     * @returns {void}
     */
    function handleTouchEnd(e) {
        // if the user released on a different target, cancel!
        if (startEl !== e.target)
            return;
        var direction;
        var changedTouches = e.changedTouches || e.touches || [];
        if (Math.abs(xDiff) > Math.abs(yDiff)) { // most significant
            if (Math.abs(xDiff) > swipeThreshold) {
                if (xDiff > 0) {
                    direction = 'left';
                }
                else {
                    direction = 'right';
                }
            }
        }
        else if (Math.abs(yDiff) > swipeThreshold) {
            if (yDiff > 0) {
                direction = 'up';
            }
            else {
                direction = 'down';
            }
        }
        if (direction) {
            var eventData = {
                dir: direction,
                touchType: (changedTouches[0] || {}).touchType || 'direct',
                xStart: parseInt(xDown, 10),
                xEnd: parseInt((changedTouches[0] || {}).clientX || -1, 10),
                yStart: parseInt(yDown, 10),
                yEnd: parseInt((changedTouches[0] || {}).clientY || -1, 10)
            };
            // fire `swiped` event event on the element that started the swipe
            startEl.dispatchEvent(new CustomEvent('swiped', { bubbles: true, cancelable: true, detail: eventData }));
            // fire `swiped-dir` event on the element that started the swipe
            startEl.dispatchEvent(new CustomEvent('swiped-' + direction, { bubbles: true, cancelable: true, detail: eventData }));
        }
        // reset values
        xDown = null;
        yDown = null;
        yVelocity = null;
        xVelocity = null;
    }
}
